import React from 'react';
import InputTextField from '../../../BuildingBlocks/Form/TextField';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  firstLastName: {
    display: 'flex',
    placeContent: 'center',
  },
  name: {
    maxWidth: 144,
  },
  gapBetweenName: {
    marginRight: theme.spacing(1.5),
  },
}));

export default function NameFields({ errors, register }) {
  const classes = useStyles();

  return (
    <div className={classes.firstLastName}>
      <InputTextField
        errors={errors}
        className={classes.name + ' ' + classes.gapBetweenName}
        label={'First Name'}
        name={'firstName'}
        TextFieldProps={{
          ...register('firstName'),
        }}
      />
      <InputTextField
        errors={errors}
        className={classes.name}
        label={'Last Name'}
        name={'lastName'}
        TextFieldProps={{
          ...register('lastName'),
        }}
      />
    </div>
  );
}
